import { APICallV4Post } from 'reactApp/api/APICall';
import type { ESortOder, ESortTypes } from 'reactApp/modules/sort/sort.types';
import type { EPublicAccessRights } from 'reactApp/modules/weblinkAccessControl/weblinkAccessControl.types';
import type { FileType } from 'reactApp/types/FileType';
import type { Kind, VirusScan } from 'reactApp/types/Tree';

// Внимание! В типах описаны в основном только используемые поля

export interface EmailAccess {
    access: EPublicAccessRights;
    email: string;
}

export interface FeedApiV4ResponseListItemPublic {
    ctime: number;
    extid: string;
    flags: {
        domestic: boolean;
        writable: boolean;
        commentable: boolean;
    };
    email_accesses?: EmailAccess[];
    // параметр вида xuHm/uUcUQFxa3
    id: string;
    name: string;
    type: string;
}

export interface FeedApiV4ResponseListItem {
    public: FeedApiV4ResponseListItemPublic;
    flags?: {
        favorite?: boolean;
    };
    kind: Kind;
    mtime: number;
    name: string;
    nodeid: string;
    path: string;
    size: number;
    type: FileType;
    hash?: string;
    home: string;
    mode_bitmask?: number;
    virus_scan: VirusScan;
}

export interface FeedApiV4Response {
    cursor?: string;
    list: FeedApiV4ResponseListItem[] | null;
}

export interface FeedApiV4Request {
    /**
     * При прередаче mtime_from и mtime_to нужно явно передать ignore_mounts: true
     */
    mtime_from?: number; // фильтр по mtime "от", включительно, mtime в секундах
    mtime_to?: number; // фильтр по mtime "до", не включительно, mtime в секундах

    cursor?: string; // курсор для пагинации
    limit?: number; // лимит результатов
    exts?: string; // нужные расширения через запятую (например, "png,tiff")
    invert_ext?: boolean; // инвертировать смысл фильтра по расширению
    include_paths?: string[]; // фильтр по префиксу пути. не больше 10 элементов
    exclude_paths?: string[]; // фильтр по префиксу пути. не больше 10 элементов
    ignore_mounts?: boolean; // выбирать объекты только в текущем дереве не погружаясь в точки монтирования
    sort?: ESortTypes | null;
    order?: ESortOder;
}

export class FeedApiCallV4 extends APICallV4Post<FeedApiV4Response, FeedApiV4Request> {
    _method = 'private/feed';
}

export interface FeedAnchorsApiV4ResponseItem {
    mtime_from: number; // начало диапазона, включительно. можно передавать в /feed как есть
    mtime_to: number; // конец диапазона, не включительно. можно передавать в /feed как есть
    count: number; // Количество фото в диапазоне
}

export interface FeedAnchorsApiV4Response {
    anchors: FeedAnchorsApiV4ResponseItem[];
}

export interface FeedAnchorsApiV4Request extends Omit<FeedApiV4Request, 'mtime_from' | 'mtime_to'> {
    timezone: string; // часовой пояс клиента, в формате "IANA Time Zone database"
}

export class FeedAnchorsApiCallV4 extends APICallV4Post<FeedAnchorsApiV4Response, FeedAnchorsApiV4Request> {
    _method = 'private/feed/anchors';
}
